export const customerRecordStatus = [
  { key: "O", badgeColor: "success" },
  { key: "C", badgeColor: "danger" },
];

export const customerRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const customerModeList = {
  VIEW_CUSTOMER_DETAIL: "VIEW_CUSTOMER_DETAIL",
  EDIT_CUSTOMER_DETAIL: "EDIT_CUSTOMER_DETAIL",
};

export const getInitCustomerParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};

export const formatToScheduleTime = originalDate => {
  const data = new Date(originalDate);
  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(data);
};

export const getCurScheduleTime = timeString => {
  const currentDate = new Date();
  const [hours, minutes] = timeString.split(":");
  currentDate.setHours(Number(hours));
  currentDate.setMinutes(Number(minutes));
  currentDate.setSeconds(0); // Set seconds to 0 to remove seconds from the Date object
  currentDate.setMilliseconds(0);
  return currentDate;
};

export const CUSTOMER_SOURCE = {
  DEFAULT: "default",
  GSCORE: "gscore",
};
